function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTablets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0C1D4"
    },
    d: "M24.5,26.5c-0.552,0-1-0.449-1-1v-23c0-0.551,0.448-1,1-1h13c0.552,0,1,0.449,1,1v23 c0,0.551-0.448,1-1,1H24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66798F"
    },
    d: "M37.5,2C37.776,2,38,2.224,38,2.5v23c0,0.276-0.224,0.5-0.5,0.5h-13c-0.276,0-0.5-0.224-0.5-0.5v-23 C24,2.224,24.224,2,24.5,2H37.5 M37.5,1h-13C23.672,1,23,1.672,23,2.5v23c0,0.828,0.672,1.5,1.5,1.5h13c0.828,0,1.5-0.672,1.5-1.5 v-23C39,1.672,38.328,1,37.5,1L37.5,1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 4.5,
    style: {
      fill: "#F2FAFF"
    },
    width: 15,
    height: 19
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66798F"
    },
    d: "M38,5v18H24V5H38 M39,4H23v20h16V4L39,4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCD5F2"
    },
    d: "M13.5,32.5c-0.552,0-1-0.449-1-1v-23c0-0.551,0.448-1,1-1h13c0.552,0,1,0.449,1,1v23 c0,0.551-0.448,1-1,1H13.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8B75A1"
    },
    d: "M26.5,8C26.776,8,27,8.224,27,8.5v23c0,0.276-0.224,0.5-0.5,0.5h-13c-0.276,0-0.5-0.224-0.5-0.5 v-23C13,8.224,13.224,8,13.5,8H26.5 M26.5,7h-13C12.672,7,12,7.672,12,8.5v23c0,0.828,0.672,1.5,1.5,1.5h13 c0.828,0,1.5-0.672,1.5-1.5v-23C28,7.672,27.328,7,26.5,7L26.5,7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 10.5,
    style: {
      fill: "#F2FAFF"
    },
    width: 15,
    height: 19
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8B75A1"
    },
    d: "M27,11v18H13V11H27 M28,10H12v20h16V10L28,10z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC49C"
    },
    d: "M2.5,38.5c-0.552,0-1-0.449-1-1v-23c0-0.551,0.448-1,1-1h13c0.552,0,1,0.449,1,1v23 c0,0.551-0.448,1-1,1H2.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A16A4A"
    },
    d: "M15.5,14c0.276,0,0.5,0.224,0.5,0.5v23c0,0.276-0.224,0.5-0.5,0.5h-13C2.224,38,2,37.776,2,37.5 v-23C2,14.224,2.224,14,2.5,14H15.5 M15.5,13h-13C1.672,13,1,13.672,1,14.5v23C1,38.328,1.672,39,2.5,39h13 c0.828,0,1.5-0.672,1.5-1.5v-23C17,13.672,16.328,13,15.5,13L15.5,13z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 16.5,
    style: {
      fill: "#F2FAFF"
    },
    width: 15,
    height: 19
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A16A4A"
    },
    d: "M16,17v18H2V17H16 M17,16H1v20h16V16L17,16z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablets);
export default __webpack_public_path__ + "static/media/tablets.f31223d4.svg";
export { ForwardRef as ReactComponent };